import React from 'react';
import classnames from 'classnames';
import { getImageUrlByName } from '../../helpers/layout';
import styles from '../../styles/components/property-id.module.scss';
import { Image } from '../images/image';

export const PropertyId = React.memo(({ imageUrl, address }) => {
  return (
    <div className={styles.container}>
      <Image
        className={styles.image}
        src={imageUrl}
        fallbackSrc={getImageUrlByName('item-card-fallback', 'jpg')}
        cover
      />
      {address && <p className={classnames(styles.address, styles.label)}>{address}</p>}
    </div>
  );
});
